"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPAliasMethods = exports.addUtilityForType = void 0;
var isTaggedAsAlias_1 = require("../../../type_system/kinds/isTaggedAsAlias.js");
var isWellFormedType_1 = require("../../../type_system/kinds/isWellFormedType.js");
var typeExtends_1 = require("../../../type_system/typeExtends.js");
var types_1 = require("../../../type_system/types.js");
var unwrapAlias_1 = require("../../../type_system/tyArgs/unwrapAlias.js");
var papp_1 = require("../../papp.js");
var TermBool_1 = require("./TermBool.js");
var TermBS_1 = require("./TermBS.js");
var TermInt_1 = require("./TermInt.js");
var TermList_1 = require("./TermList.js");
var TermPair_1 = require("./TermPair.js");
var TermStr_1 = require("./TermStr.js");
var TermStruct_1 = require("./TermStruct.js");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var utils_1 = require("../../../type_system/utils.js");
var addUserMethods_1 = require("./userMethods/addUserMethods.js");
var BaseUtilityTerm_1 = require("./BaseUtilityTerm.js");
function addUtilityForType(t) {
    if ((0, isTaggedAsAlias_1.isTaggedAsAlias)(t)) {
        return addPAliasMethods;
        // return addUtilityForType( unwrapAlias( t ) ) as any;
    }
    ;
    if ((0, typeExtends_1.typeExtends)(t, types_1.bool))
        return TermBool_1.addPBoolMethods;
    if ((0, typeExtends_1.typeExtends)(t, types_1.bs))
        return TermBS_1.addPByteStringMethods;
    if ((0, typeExtends_1.typeExtends)(t, types_1.int))
        return TermInt_1.addPIntMethods;
    if ((0, typeExtends_1.typeExtends)(t, (0, types_1.list)((0, types_1.tyVar)())))
        return TermList_1.addPListMethods;
    if ((0, typeExtends_1.typeExtends)(t, (0, types_1.pair)((0, types_1.tyVar)(), (0, types_1.tyVar)())))
        return TermPair_1.addPPairMethods;
    if ((0, typeExtends_1.typeExtends)(t, types_1.str))
        return TermStr_1.addPStringMethods;
    if ((0, typeExtends_1.typeExtends)(t, (0, types_1.lam)((0, types_1.tyVar)(), (0, types_1.tyVar)()))) {
        return (function (term) {
            term = (0, BaseUtilityTerm_1.addBaseUtilityTerm)(term);
            return (0, obj_utils_1.defineNonDeletableNormalProperty)(term, "$", function (input) {
                return (0, papp_1.papp)(term, input);
            });
        });
    }
    if ((0, isWellFormedType_1.isStructType)(t)) {
        return TermStruct_1.addPStructMethods;
    }
    // no utility
    return (function (x) { return (0, BaseUtilityTerm_1.addBaseUtilityTerm)(x); });
}
exports.addUtilityForType = addUtilityForType;
// `addPAliasMethod` is (necessarily) mutually recursive with `addUtilityForType`
// so it is defined in this file instead of "./UtilityTerms/TermAlias.ts"
function addPAliasMethods(aliasTerm) {
    var originalType = aliasTerm.type;
    aliasTerm = (0, BaseUtilityTerm_1.addBaseUtilityTerm)(aliasTerm);
    if (originalType[0] !== types_1.PrimType.Alias) {
        console.error(originalType);
        try {
            console.error((0, utils_1.termTypeToString)(originalType));
        }
        catch (_a) { }
        throw new Error("addPAliasMethods used on non-alias type");
    }
    var aliasedType = (0, unwrapAlias_1.unwrapAlias)(originalType);
    // intentionally discarding the result
    // if we are aliasing a list, adding utility clones the term
    // so changes the type
    // so we loose the alias and possible methods
    // this is really a bug in `addPListMethods`
    // but for now this is the workaround
    void addUtilityForType(aliasedType)(aliasTerm);
    void (0, addUserMethods_1.addUserMethods)(aliasTerm, originalType[2]);
    return aliasTerm;
}
exports.addPAliasMethods = addPAliasMethods;
